import { atom } from 'recoil';
import { CollectionAddressType } from '@/mobile/types/api/mypage/collectionAddress';

// 選択された集荷先住所の状態管理
export type SelectedCollectionAddressType = {
  address: string | CollectionAddressType | null;
  phone?: string;
  selectedOption?: 'shipping' | 'custom';
};

const selectedCollectionAddressState = atom<SelectedCollectionAddressType>({
  key: 'selectedCollectionAddressState',
  default: {
    // 初期表示では配送先住所を既定選択にし、未選択状態の追加分岐を減らす。
    address: '',
    selectedOption: 'shipping',
  },
});

export default selectedCollectionAddressState;
